import { render, staticRenderFns } from "./Warning.vue?vue&type=template&id=77d81cb3&scoped=true&lang=pug"
import script from "./Warning.vue?vue&type=script&lang=js"
export * from "./Warning.vue?vue&type=script&lang=js"
import style0 from "./Warning.vue?vue&type=style&index=0&id=77d81cb3&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d81cb3",
  null
  
)

export default component.exports